const STORAGE_KEY = "pb.admin.reviewInbox.filters";

/**
 * @typedef {{
 *   tier?: string,
 *   type?: string,
 *   school?: string,
 *   covMin?: number|null,
 *   covMax?: number|null,
 *   bodyMode?: string,
 * }} ReviewFilters
 */

/**
 * @return {ReviewFilters|null}
 */
export function loadReviewFilters() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

/**
 * @param {ReviewFilters} filters
 */
export function saveReviewFilters(filters) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filters || {}));
  } catch {
    // ignore quota / private mode
  }
}

export function clearReviewFiltersStorage() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/**
 * @param {ReviewFilters|null|undefined} filters
 * @return {URLSearchParams}
 */
export function reviewFiltersToSearchParams(filters) {
  const params = new URLSearchParams();
  if (!filters) return params;
  if (filters.tier) params.set("tier", String(filters.tier));
  if (filters.type) params.set("type", String(filters.type));
  if (filters.school) params.set("school", String(filters.school));
  if (
    typeof filters.covMin === "number" &&
    typeof filters.covMax === "number" &&
    (filters.covMin > 0 || filters.covMax < 100)
  ) {
    params.set("covMin", String(filters.covMin));
    params.set("covMax", String(filters.covMax));
  }
  if (filters.bodyMode && filters.bodyMode !== "template") {
    params.set("body", String(filters.bodyMode));
  }
  return params;
}

/**
 * Href for the review inbox, restoring last-used filters when present.
 * @return {string}
 */
export function reviewInboxPath() {
  const qs = reviewFiltersToSearchParams(loadReviewFilters()).toString();
  return qs ? `/review?${qs}` : "/review";
}
